var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto mt-4"},[_c('GridEditor',{attrs:{"title":"Geo Record Models","gridType":"Geo Record Model","isActions":true,"getDataCallback":_vm.getAllGeoRecordModels,"deleteDataCallback":_vm.deleteGeoRecordModel,"gridConfig":_vm.tableColumns,"editorComponent":_vm.GeoRecordModelEditor,"editorProps":{
            geoRecords: _vm.geoRecords,
        },"numOfRows":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }